module.exports = __webpack_public_path__ + "media/images/browseranalysis-3b6d6ecde49286f4740c2b5523243ef6.svg";